// Per-page seeded suggestion chips for the empty/idle copilot dock
// (scenario 685, plan 188 W2-M8 task 802). Pure function of the current
// route — no data fetching — so the dock never blocks on a name lookup before
// showing chips. `/people/:contactId` chips use generic "this person" phrasing
// rather than a fetched display name (see the work-complete report's Residual
// risk section for the tradeoff).

export type SuggestionChip = {
  id: string;
  label: string;
  prompt: string;
};

const DEFAULT_CHIPS: SuggestionChip[] = [
  { id: "today", label: "What needs my attention today?", prompt: "What needs my attention today?" },
  { id: "going-cold", label: "Who's going cold?", prompt: "Who in my book is going cold?" },
];

const ROUTE_CHIPS: { test: (pathname: string) => boolean; chips: SuggestionChip[] }[] = [
  {
    test: (p) => p.startsWith("/home") || p.startsWith("/tasks"),
    chips: [
      { id: "today-attention", label: "What needs my attention today?", prompt: "What needs my attention today?" },
      { id: "today-followups", label: "Who needs a follow-up?", prompt: "Who needs a follow-up right now?" },
    ],
  },
  // Plan 372 (SILL-499): /clients/:profileId and /contacts retired in favour of
  // /people/:contactId and /people. Matching the old paths left these chips
  // dead on every People surface (the retired routes now redirect, so the
  // matcher never fired and the dock fell through to DEFAULT_CHIPS).
  {
    test: (p) => /^\/people\/[^/]+/.test(p),
    chips: [
      { id: "person-summary", label: "Summarize this person", prompt: "Summarize this person." },
      { id: "person-followup", label: "Draft a follow-up", prompt: "Draft a follow-up message to this person." },
    ],
  },
  {
    test: (p) => p.startsWith("/people"),
    chips: [
      { id: "people-followup", label: "Who needs a follow-up?", prompt: "Who in my book needs a follow-up?" },
      { id: "people-uninvited", label: "Who isn't on Sill yet?", prompt: "Who in my book hasn't joined Sill yet?" },
    ],
  },
  {
    test: (p) => p.startsWith("/campaigns"),
    chips: [
      { id: "campaign-results", label: "How did my last campaign do?", prompt: "How did my last campaign do?" },
      { id: "campaign-draft", label: "Draft a campaign to people going cold", prompt: "Draft a campaign to people who are going cold." },
    ],
  },
];

export function suggestionChipsForRoute(pathname: string): SuggestionChip[] {
  const match = ROUTE_CHIPS.find((entry) => entry.test(pathname));
  return match ? match.chips : DEFAULT_CHIPS;
}
